(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mega-menu-category-grid"] && !Shopify.designMode) return;
  try {
    function activateCategoryTab(tab) {
    if (tab.classList.contains('is-active')) return;

    const rail = tab.closest('.mega-menu-category__rail');
    const menu = tab.closest('.mega-menu-category');
    const panel = document.getElementById(tab.getAttribute('aria-controls') || '');
    if (!rail || !menu || !panel) return;

    rail.querySelectorAll('.mega-menu-category__tab.is-active').forEach((el) => el.classList.remove('is-active'));
    menu.querySelectorAll('.mega-menu-category__panel.is-active').forEach((el) => el.classList.remove('is-active'));
    tab.classList.add('is-active');
    panel.classList.add('is-active');

    const headerComponent = menu.closest('#header-component');
    const submenu = menu.closest('.menu-list__submenu');
    if (!(headerComponent instanceof HTMLElement) || !(submenu instanceof HTMLElement)) return;

    // Re-run the same measurement header-menu.js does on open, since switching
    // panels here doesn't trigger its mutation observer (no nodes are added or
    // removed, only a class toggle).
    requestAnimationFrame(() => {
      const computed = getComputedStyle(headerComponent);
      const previousFullHeight = parseFloat(computed.getPropertyValue('--full-open-header-height')) || 0;
      const previousSubmenuHeight = parseFloat(computed.getPropertyValue('--submenu-height')) || 0;
      const headerVisibleHeight = previousFullHeight - previousSubmenuHeight;
      const submenuHeight = submenu.offsetHeight;

      headerComponent.style.setProperty('--submenu-height', `${submenuHeight}px`);
      headerComponent.style.setProperty('--full-open-header-height', `${submenuHeight + headerVisibleHeight}px`);
    });
  }

  document.addEventListener('pointerover', (event) => {
    if (!(event.target instanceof Element)) return;
    const tab = event.target.closest('.mega-menu-category__tab');
    if (tab) activateCategoryTab(tab);
  });

  document.addEventListener('focusin', (event) => {
    if (!(event.target instanceof Element)) return;
    const tab = event.target.closest('.mega-menu-category__tab');
    if (tab) activateCategoryTab(tab);
  });

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const button = event.target.closest('.mega-menu-category__pagination-button');
    if (!button) return;

    const list = button.closest('.mega-menu-category__panel')?.querySelector('.mega-menu-category__products');
    if (!list) return;

    const amount = list.clientWidth * 0.9 * (button.getAttribute('data-scroll-direction') === 'prev' ? -1 : 1);
    list.scrollBy({ left: amount, behavior: 'smooth' });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["video-toggle"] && !Shopify.designMode) return;
  try {
    class VideoToggle extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('.video-toggle__button');
      this.scope = this.closest(this.dataset.scope) ?? this.parentElement;
      if (!this.button || !this.scope) return;

      this.button.addEventListener('click', this.#toggle);
      // Media events do not bubble, so listen in the capture phase on the scope.
      this.scope.addEventListener('play', this.#sync, true);
      this.scope.addEventListener('pause', this.#sync, true);
      this.#sync();
    }

    disconnectedCallback() {
      this.button?.removeEventListener('click', this.#toggle);
      this.scope?.removeEventListener('play', this.#sync, true);
      this.scope?.removeEventListener('pause', this.#sync, true);
    }

    /** Videos that are actually displayed (the hero renders separate desktop and mobile videos). */
    #videos() {
      return Array.from(this.scope.querySelectorAll('video')).filter((video) => video.offsetParent !== null);
    }

    #sync = () => {
      const videos = this.#videos();
      this.hidden = videos.length === 0;
      const isPlaying = videos.some((video) => !video.paused);

      this.dataset.state = isPlaying ? 'playing' : 'paused';
      this.button.setAttribute('aria-label', isPlaying ? this.dataset.pauseLabel : this.dataset.playLabel);
    };

    #toggle = () => {
      const videos = this.#videos();
      const isPlaying = videos.some((video) => !video.paused);

      videos.forEach((video) => {
        if (isPlaying) {
          video.pause();
        } else {
          video.play().catch(() => {});
        }
      });
      this.#sync();
    };
  }

  if (!customElements.get('video-toggle')) {
    customElements.define('video-toggle', VideoToggle);
  }
  } catch(e) { console.error(e); }
})();

})();
